import React from 'react';
import { Link } from 'react-router-dom';

class GlobalErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("GlobalErrorBoundary Caught Error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '40px',
                    maxWidth: '800px',
                    margin: '0 auto',
                    fontFamily: 'system-ui, sans-serif',
                    color: '#333'
                }}>
                    <div style={{
                        backgroundColor: '#fff0f0',
                        border: '1px solid #ffcdd2',
                        borderRadius: '8px',
                        padding: '24px'
                    }}>
                        <h2 style={{ marginTop: 0, color: '#d32f2f' }}>Something went wrong.</h2>
                        <p>The application encountered an unexpected error.</p>

                        <details style={{ whiteSpace: 'pre-wrap', marginTop: '16px', backgroundColor: '#fff', padding: '12px', border: '1px solid #eee', borderRadius: '4px' }}>
                            <summary style={{ cursor: 'pointer', color: '#666', marginBottom: '8px' }}>View Error Details</summary>
                            <span style={{ color: '#d32f2f', fontWeight: 'bold' }}>{this.state.error?.toString()}</span>
                            <br />
                            <span style={{ fontSize: '0.85em', color: '#666' }}>{this.state.errorInfo?.componentStack}</span>
                        </details>

                        <div style={{ marginTop: '24px' }}>
                            <button
                                onClick={() => window.location.reload()}
                                style={{
                                    backgroundColor: '#d32f2f',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 20px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '1rem',
                                    marginRight: '12px'
                                }}
                            >
                                Reload Page
                            </button>
                            <Link to="/" style={{ color: '#d32f2f', textDecoration: 'underline' }}>
                                Back to Home
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
